<template>
  <multi-step-dialog title="Select a Workout Collection" :step="step" ref="dialog" :can-confirm="!!collectionId" @confirm="confirm" :confirm-hint="selectionSummary">
    <v-stepper-items>
      <v-stepper-content :step="1" class="pa-0">
        <div v-if="!collections" class="text-center">
          <v-progress-circular indeterminate :size="100" :width="5" color="primary" class="mx-a"></v-progress-circular>
        </div>
        <v-container v-if="collections">
          <p>Select a collection for details and to apply.</p>
          <v-row>
            <v-col v-for="(item, idx) in collections" :key="idx" cols="12" md="6" lg="4">
              <workout-collection-card :item="item" @click="nextStep" />
            </v-col>
          </v-row>
        </v-container>

      </v-stepper-content>
      <v-stepper-content :step="2" class="pa-0">
        <v-container v-if="collection">
          <v-row>
            <v-col>
              <h4>{{ collection.title }}</h4>
              <p>{{ collection.description }}</p>

              <h4>Videos</h4>
              <v-alert v-if="advisedVideos" text type="info">
                Based on a challenge duration of {{ durationDays }} days, we advise to include {{ advisedVideos }} videos in this challenge. We have pre-selected these for you, but feel free to make changes to the video selection based on your preferences.
              </v-alert>
              <div v-if="!videos" class="text-center">
                <v-progress-circular indeterminate :size="100" :width="5" color="primary" class="mx-a"></v-progress-circular>
              </div>
              <div v-if="videos">
                <p>These videos are included in the selected collection.</p>
                <p>
                  <v-btn text small color="accent" @click="selectAll(true)">Select all</v-btn>
                  <v-btn text small color="accent" @click="selectAll(false)">Deselect all</v-btn>
                </p>
                <v-row>
                  <v-col v-for="(item, idx) in videos" :key="idx" cols="12" class="relative">
                    <v-checkbox 
                      v-if="allowVideoSelection"
                      v-model="selectedVideoIds"
                      label="Include this video"
                      :value="item.id"
                      style="position: absolute; top: 0px; right: 15px; z-index:4; background: white;"
                      hide-details
                      />
                    <workout-video-card :item="item" />
                  </v-col>
                </v-row>
              </div>

            </v-col>
          </v-row>
        </v-container>
      </v-stepper-content>
    </v-stepper-items>
  </multi-step-dialog>
</template>

<script>
import { DateTime } from 'luxon'
import siteData from '@/data/site.json'
import assetsService from "@/services/assetsService";
import MultiStepDialog from "@/components/generic/MultiStepDialog.vue";
import WorkoutCollectionCard from '../workouts/WorkoutCollectionCard.vue';
import WorkoutVideoCard from '../workouts/WorkoutVideoCard.vue';

export default {
  name: "SelectWorkoutCollectionDialog",
  components: {
    MultiStepDialog,
    WorkoutCollectionCard,
    WorkoutVideoCard,
  },
  props: {
    value: String,
    from: String,
    till: String,
  },
  data() {
    return {
      siteData: siteData,
      step: 1,
      collections: null,
      collectionId: null,
      videos: null,
      allowVideoSelection: true,
      durationDays: null,
      selectedVideoIds: [],
    };
  },
  async mounted() {
  },
  methods: {

    async open() {
      this.step = 1;
      this.$refs.dialog.open();
      this.collections = this.collections || (await assetsService.getWorkoutCollections()).data.data;
      this.durationDays = this.from && this.till ? this.$helpers.getDaysBetween(this.from, this.till) : null;
      this.advisedVideos = this.durationDays ? Math.round(this.durationDays / 5) : null;
    },

    async selectAll(value) {
      this.selectedVideoIds = value ? this.videos.map(x => x.id) : [];
    },
    async nextStep(value) {
      this.collectionId = value;
      this.step = 2;
      var response = (await assetsService.getWorkoutCollection(this.collectionId)).data;
      this.videos = response.videos;

      if (this.advisedVideos) {
        this.selectedVideoIds = this.videos.map(x => x.id).slice(0, this.advisedVideos);
      }
      else {
        this.selectedVideoIds = this.videos.map(x => x.id);
      }
    },

    async confirm() {
      this.$emit('input', this.collectionId);
      this.$emit('confirm', { 
        id: this.collectionId,
        collection: this.collection,
        selectedVideoIds: this.selectedVideoIds,
      });
    }

  },

  computed: {
    selectionSummary() {
      if (!this.selectedVideoIds || !this.selectedVideoIds.length) {
        return '';
      }
      return `${this.selectedVideoIds.length} videos selected`;
    },
    collection() {
      if (!this.collectionId) {
        return null;
      }
      return this.collections.find(x => x.id == this.collectionId);
    }
  },

};
</script>
<style lang="scss">
.v-card.active { outline: solid 5px var(--v-accent-base);}
</style>

